<template>
  <div :style="{width: width, height: height}" id="chart" ref="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      required: true,
      type: Array,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '450px',
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      legendCount: 5,
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
      'am4Charts',
    ]),
  },
  methods: {
    loaded() {
      setTimeout(() => {
        this.$emit('update-step', 2);
      }, 800);
    },
    generateGraphics() {
      const vm = this;
      this.chart = this.am4core.create(this.$refs.chart, this.am4Charts.SlicedChart);
      this.chart.data = this.data; // insert data to graphic
      this.chart.legend = new this.am4Charts.Legend(); // initialize legends
      this.chart.numberFormatter.numberFormat = '#,###';

      // insert series
      this.chart.events.on('ready', () => this.loaded());
      const series = this.chart.series.push(new this.am4Charts.FunnelSeries());
      // customizing serie
      series.y = 0;
      series.alignLabels = true; // labels aside the graphic
      series.dataFields.value = 'value'; // field that has the value
      series.dataFields.percent = 'percent'; // field that has the value
      series.labels.template.width = 150;
      series.labelsContainer.width = 110; // width of the labels parent
      series.dataFields.category = 'name'; // field that has the name
      series.height = this.am4core.percent(80); // height of div/canvas parent
      series.labels.template.fontSize = 12;
      series.ticks.template.disabled = true;
      series.labels.template.fontWeight = 200;
      series.marginLeft = this.am4core.percent(-30);
      series.marginRight = this.am4core.percent(0);
      series.labels.template.text = '{value}';
      series.tooltip.disabled = true;


      // default colors to series
      series.colors.list = [
        this.am4core.color('#31939d'),
        this.am4core.color('#46ccd9'),
        this.am4core.color('#47beb7'),
        this.am4core.color('#55c187'),
        this.am4core.color('#66e59f'),
      ];

      // customizing legend
      const legend = this.chart.legend;
      legend.zIndex = 500;
      legend.fontSize = 12;// legend font size
      legend.marginLeft = 0;
      legend.position = 'left';// legend position in graphic
      legend.useDefaultMarker = true;
      legend.valueLabels.template.text = '';// set the value in legends empty
      legend.marginTop = this.am4core.percent(125);
      legend.width = this.am4core.percent(50);
      series.slices.template.events.on('hit', (ev) => {
        vm.$emit('show-info', ev.target.dataItem.dataContext.name);
      });
      this.chart.legend.itemContainers.template.events.on('hit', (ev) => {
        if (ev.target.isActive) {
          this.legendCount += 1;
        } else {
          this.legendCount -= 1;
        }
        series.height = this.am4core.percent((80 * this.legendCount) / 5);
      });
      // customizing each legend item
      const legendItemTemplate = legend.itemContainers.template;
      legendItemTemplate.paddingTop = 0;

      // customizing legend markers
      const markers = legend.markers.template;
      // size of markers in legend
      markers.width = 15;
      markers.height = 15;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data; // insert data to graphic
      },
    },
  },
};
</script>
<style scoped>
#chart {
  width: 100%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/Schedule/Funnel.vue